import { useState } from 'react'
import { Button } from '../common/Button'
import { Card } from '../common/Card'
import type { Challenge, ChallengeAnswer } from '../../types'

interface QuestionChallengeProps {
  challenge: Challenge
  onSubmit: (answer: ChallengeAnswer) => void
  isSubmitting: boolean
  debugMode?: boolean
}

export function QuestionChallenge({
  challenge,
  onSubmit,
  isSubmitting,
  debugMode,
}: QuestionChallengeProps) {
  const [answer, setAnswer] = useState('')

  const handleSubmit = () => {
    if (answer.trim()) {
      onSubmit({ answer: answer.trim() })
    }
  }

  return (
    <div className="space-y-4">
      <Card variant="parchment" padding="md">
        <p className="text-brown-800 italic">
          "{challenge.question || challenge.instructions}"
        </p>
      </Card>

      <input
        type="text"
        value={answer}
        onChange={(e) => setAnswer(e.target.value)}
        placeholder="Type your answer..."
        className="w-full px-4 py-3 rounded-lg border-2 border-cream-200 focus:border-primary-500 focus:outline-none text-brown-900"
        onKeyDown={(e) => e.key === 'Enter' && handleSubmit()}
        disabled={isSubmitting}
      />

      {debugMode && challenge.debug_answer && (
        <p className="text-xs text-brown-400">
          Debug answer: {challenge.debug_answer}
        </p>
      )}

      <Button
        onClick={handleSubmit}
        disabled={!answer.trim() || isSubmitting}
        loading={isSubmitting}
        className="w-full"
      >
        Submit Answer
      </Button>
    </div>
  )
}
